// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__VC52B","choiceBoxes":"toolbarselects_choiceBoxes__2ycXo","simpleField":"toolbarselects_simpleField__2at2t"};